import shareableLinkTpl from '../templates/creative_preview/shareable_link.directive.html';

function ShareableLinkController(
  $scope,
  CreativeService,
  MixpanelService,
  RenderService,
  ShareableLinkService
) {
  const vm = this;
  vm.previewLink = '';
  vm.mixpanelService = MixpanelService;

  $scope.$watchGroup(
    [() => CreativeService.creative, () => RenderService.site],
    buildPreviewLink
  );

  return vm;

  function buildPreviewLink() {
    if ($scope.edit) {
      vm.previewLink = ShareableLinkService.buildEditUrl();
    } else {
      vm.previewLink = ShareableLinkService.buildShareUrl();
    }
  }
}

ShareableLinkController.$inject = [
  '$scope',
  'CreativeService',
  'MixpanelService',
  'RenderService',
  'ShareableLinkService'
];

export default function strShareableLink() {
  return {
    restrict: 'EA',
    template: shareableLinkTpl,
    controller: ShareableLinkController,
    controllerAs: 'vm',
    scope: {
      edit: '='
    }
  };
}
